import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/banner/7.jpg');

const ContactUs = () => {
    const formRef = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_c9njn1a',    // Service ID
            'template_dtb0dif',   // Template ID
            formRef.current,
            'o6SoaTtViB9HMyF1H'   // Public Key
        )
        .then((result) => {
            console.log('Wiadomość wysłana:', result.text);
            alert('Twoja wiadomość została wysłana!');
            formRef.current.reset(); // Czyszczenie formularza po wysłaniu
        })
        .catch((error) => {
            console.error('Błąd:', error.text);
            alert('Wystąpił błąd. Spróbuj ponownie.');
        });
    };

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title="MASZ PYTANIA? SKONTAKTUJ SIĘ Z NAMI!" pagename="Kontakt" bgimage={bnrimg} />
                
                {/* SECTION CONTENT START */}
                <div className="section-full p-tb80 inner-page-padding">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-8 col-sm-6">
                                    {/* FORMULARZ KONTAKTOWY */}
                                    <form ref={formRef} onSubmit={sendEmail} className="contact-form cons-contact-form">
                                        <div className="contact-one m-b30">
                                            {/* TYTUŁ FORMULARZA */}
                                            <div className="section-head">
                                                <div className="mt-separator-outer separator-left">
                                                    <div className="mt-separator">
                                                        <h2 className="text-uppercase sep-line-one">
                                                            <span className="font-weight-300 text-primary">Napisz</span> do nas
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* POLA FORMULARZA */}
                                            <div className="form-group">
                                                <input name="user_name" type="text" required className="form-control" placeholder="Imię" />
                                            </div>
                                            <div className="form-group">
                                                <input name="user_email" type="email" className="form-control" required placeholder="Email" />
                                            </div>
                                            <div className="form-group">
                                                <textarea name="message" rows={4} className="form-control" required placeholder="Wiadomość"></textarea>
                                            </div>
                                            
                                            {/* PRZYCISK WYSYŁANIA */}
                                            <div className="text-right">
                                                <button type="submit" className="site-button btn-effect">Wyślij</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="col-md-4 col-sm-6">
                                    {/* INFORMACJE KONTAKTOWE */}
                                    <div className="contact-info m-b30">
                                        <div className="section-head">
                                            <div className="mt-separator-outer separator-left">
                                                <div className="mt-separator">
                                                    <h2 className="text-uppercase sep-line-one">
                                                        <span className="font-weight-300 text-primary">Informacje</span> Kontaktowe
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bg-dark p-a20 text-white">
                                            <div className="mt-icon-box-wraper left p-b40">
                                                <div className="icon-xs"><i className="fa fa-phone" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0 font-weight-500">Telefon</h5>
                                                    <p>PL +48 500 073 261</p>
                                                    <p>ENG/PL +48 602 762 478</p>
                                                </div>
                                            </div>
                                            <div className="mt-icon-box-wraper left p-b40">
                                                <div className="icon-xs"><i className="fa fa-envelope" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0 font-weight-500">Email</h5>
                                                    <p>biuro@skate-arena.pl</p>
                                                </div>
                                            </div>
                                            <div className="mt-icon-box-wraper left">
                                                <div className="icon-xs"><i className="fa fa-map-marker" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0 font-weight-500">Adres</h5>
                                                    <p>Pokoleń Lechii Gdańsk 1, 80-001 Gdańsk, Poland
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                            
                            <div className="gmap-outline" style={{ height: '400px', width: '100%' }}>
      <iframe 
        width="100%" 
        height="100%" 
        frameborder="0" 
        scrolling="no" 
        marginheight="0" 
        marginwidth="0" 
        src="https://www.openstreetmap.org/export/embed.html?bbox=18.633048534393314%2C54.38678661234923%2C18.650450706481937%2C54.392215342541164&amp;layer=mapnik&amp;marker=54.389501067218134%2C18.641749620437622"
        style={{ border: '1px solid black' }}
      >
      </iframe>
      <br/>
      <small>
      <a href="https://www.openstreetmap.org/?mlat=54.38950&amp;mlon=18.64175#map=17/54.38950/18.64175&amp;layers=N">

          Powiększ mapę
        </a>
      </small>
    </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END */}
                </div>


                <Footer />

            </>
        );
    };


export default ContactUs;
